export const FILTER_VALUE_FINALIZADOS = "finalizados";
export const FILTER_VALUE_ACTIVOS = "activos";
export const FILTER_VALUE_MIS_CHATS = "misChats";